export * as tasks from '@wix/auto_sdk_data_tasks/meta';
export * as permissions from '@wix/auto_sdk_data_permissions/meta';
export * as sharing from '@wix/auto_sdk_data_sharing/meta';
export * as externalDatabaseConnections from '@wix/auto_sdk_data_external-database-connections/meta';
export * as backups from '@wix/auto_sdk_data_backups/meta';
export * as collections from '@wix/auto_sdk_data_collections/meta';
export * as indexes from '@wix/auto_sdk_data_indexes/meta';
export * as movementJobs from '@wix/auto_sdk_data_movement-jobs/meta';
export * as items from '@wix/wix-data-items-sdk/meta';
